const article = {
    id: 'pii-keys',
    title: 'PII keys on a client',
    summary: 'Add, edit, or remove a client’s PII keys and the values each key accepts.',
    publishedAt: '2026-09-01',
    tags: ['clients', 'pii'],
    sections: [
        {
            type: 'paragraph',
            text: 'Each client can have its own PII keys. From the client list you can set the key name and the acceptable values, including clearing every key when the client should have none.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it when a client’s PII fields change, or when a key should accept more than one value.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Client.',
                'On the client row, click PII Keys.',
                'Add or edit a key, and set Acceptable Values. You can enter several values for one key.',
                'Remove keys you no longer need. You can clear all of them.',
                'Click Save.',
            ],
        },
    ],
};

export default article;
